import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import PageHeader from "../../shared/PageHeader";
import { FaHospital } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import ProfileVisitDetails from "../../components/his/visits/ProfileVisitDetails";
import CustomPagination from "../../shared/CustomPagination";
import SkeletonCardLoading from "../../shared/SkeltonCardLoading";
import { useGetPatientVisitsQuery } from "../../redux/api/modules/beneficiaryApi";

function ProfileVisits() {
  const { t } = useTranslation();
  const selectedPatientData = useSelector(
    (state) => state?.beneficiary?.seletedPatientData
  );

  const [pagination, setPagination] = useState({
    page: 1,
    perpage: 10,
  });

  const queryPayload = useMemo(() => ({
    page: pagination.page,
    perpage: pagination.perpage,
    patient_id: selectedPatientData?.patient_id,
    file_no: selectedPatientData?.file_no,
  }), [pagination, selectedPatientData?.patient_id, selectedPatientData?.file_no]);

  const {
    data,
    isLoading: queryLoading,
    isFetching: queryFetching,
  } = useGetPatientVisitsQuery(queryPayload, {
    skip: !queryPayload?.patient_id && !queryPayload?.file_no,
  });

  const loading = queryLoading || queryFetching;

  const onPageChange = (newPage, newRowsPerPage) => {
    setPagination({
      page: newPage,
      perpage: newRowsPerPage || 10,
    });
  };

  const visitsList = data?.data || [];

  return (
    <div className="main-page-container">
      <PageHeader title={t("Patient Visits")} Icon={FaHospital}></PageHeader>
      <div className="mt-4 flex items-center justify-center flex-col gap-2">
        {loading ? (
          <div className="grid grid-cols-1 w-full gap-y-2">
            {[...Array(4)].map((_, index) => (
              <SkeletonCardLoading
                key={index}
                count={4}
                parentClassName="w-full shadow-lg bg-white rounded-md py-4"
              />
            ))}
          </div>
        ) : visitsList.length > 0 ? (
          visitsList.map((visit, index) => (
            <ProfileVisitDetails
              key={visit?.visit_id || index}
              visitData={visit}
            />
          ))
        ) : (
          <div className="text-center py-10">{t("No Visits Found")}</div>
        )}
        {visitsList.length > 0 && (
          <CustomPagination
            currentPage={data?.page || pagination.page}
            rowsPerPage={data?.perPage || pagination.perpage}
            totalRecords={data?.totalCount || 0}
            totalPages={data?.totalPages || 1}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
}

export default ProfileVisits;
